// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TimePoint-module-timePoint {
  display: flex;
  flex-direction: column;
  gap: 15px;
  align-items: center;
  text-align: center;
  flex-shrink: 0;
  width: 92px;
}

.TimePoint-module-timePointDot {
  width: 20px;
  height: 20px;
  background-color: var(--college-democrats-blue);
  border-radius: 100%;
}`, "",{"version":3,"sources":["webpack://./src/pages/MembershipPage/components/TimePoint/TimePoint.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+CAA+C;EAC/C,mBAAmB;AACrB","sourcesContent":[".timePoint {\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n  align-items: center;\n  text-align: center;\n  flex-shrink: 0;\n  width: 92px;\n}\n\n.timePointDot {\n  width: 20px;\n  height: 20px;\n  background-color: var(--college-democrats-blue);\n  border-radius: 100%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"timePoint": `TimePoint-module-timePoint`,
	"timePointDot": `TimePoint-module-timePointDot`
};
export default ___CSS_LOADER_EXPORT___;
